export const redirectToExternalUrl = (
  url: string,
  options?: { openInNewTab?: boolean; replace?: boolean },
) => {
  if (options?.replace) {
    window.location.replace(url)
  } else if (options?.openInNewTab) {
    window.open(url, '_blank')
  } else {
    window.location.href = url
  }
}
